import { SlotGameType1_2_2Screen } from "../SlotGameType1_2_2Screen";
import { Scale} from "../.././MyHelpers";
import { IReadOnlyResourceManager, LoadingStage, ResourceManager } from "../../ResourceManager/ResourceManager";

//namespace SlotGames2 {
    export class SpiritOfThunder2_2Screen extends SlotGameType1_2_2Screen {
        public override PrepareFont(resourceManager: ResourceManager) {
            //resourceManager.Add(new FontResource(this.basepath + "resources/huggable.ttf", "." + this.resid.ScopedResourceName("font")));
            // resourceManager.Add(new FontResource(this.basepath + "resources/montana.ttf",  this.resid.ScopedResourceName(["font"])));
            // resourceManager.Add(new FontResource(this.basepath + "resources/montana.ttf", this.resid.ScopedResourceName(["BigSymbolFreegames2-font"])));
        }

        public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
           await super.ResourcesLoaded(loadingStage, resourceManager);

            if (loadingStage != LoadingStage.Games) {
                return;
            }
            this.title.style.width = Scale.Wpx(1215);
            this.title.style.height = Scale.Hpx(520);
            this.title.style.backgroundSize = "contain";
    }

    }
//}